module.exports = __webpack_public_path__ + "img/8.b0cd9263.svg";